import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const UserTypeService = { 
  /**
   * Get Screen data
   *
   * */ 
  async getCustomRequest(requestScreenData) {
    return await ApiService.oDataGet(requestScreenData);
  },

  async saveUserType(payload){
    var url = "api/ApplicationUserTypeManagement";
    return await ApiService.post(url, payload);
  }
};

export default UserTypeService;

export { UserTypeService };